import type { SVGProps } from "react";
import * as React from "react";

const SvgCast = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.2 15.12a1 1 0 1 0-.4 1.96zm2.72 5.08a1 1 0 1 0 1.96-.4zm-2.81-9.144a1 1 0 0 0-.22 1.988zm6.846 9.055a1 1 0 0 0 1.988-.221zM1 8a1 1 0 0 0 2 0zm3-4V3zm16 0V3zm-6 15a1 1 0 1 0 0 2zM2 19a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zm-.21-3.92a4 4 0 0 1 2.03 1.09l1.413-1.414A6 6 0 0 0 2.2 15.12zm2.03 1.09a4 4 0 0 1 1.09 2.03l1.96-.4a6 6 0 0 0-1.637-3.044zm-1.94-5.126a8 8 0 0 1 4.772 2.294l1.414-1.414a10 10 0 0 0-5.965-2.868zm4.772 2.294a8 8 0 0 1 2.294 4.772l1.988-.22a10 10 0 0 0-2.868-5.966zM3 8V6H1v2zm0-2a1 1 0 0 1 .293-.707L1.879 3.879A3 3 0 0 0 1 6zm.293-.707A1 1 0 0 1 4 5V3a3 3 0 0 0-2.121.879zM4 5h16V3H4zm16 0a1 1 0 0 1 .707.293l1.414-1.414A3 3 0 0 0 20 3zm.707.293A1 1 0 0 1 21 6h2a3 3 0 0 0-.879-2.121zM21 6v12h2V6zm0 12a1 1 0 0 1-.293.707l1.414 1.414A3 3 0 0 0 23 18zm-.293.707A1 1 0 0 1 20 19v2a3 3 0 0 0 2.121-.879zM20 19h-6v2h6zM2 21h.01v-2H2z"
    />
  </svg>
);
export default SvgCast;
